import React from 'react';
import { stub } from '@xsk/frontend-skeleton';
import { Button } from 'antd';

class SealDataDetailComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {}
        };
    }

    componentWillMount() {
        stub.api.get(stub.module.cleanSealData.sealDataDetailUrl, {params: {id: this.props.page.params.id}}).then(res => {
            if (res) {
                this.dataHandle(res);
            }
        })
    }

    dataHandle = res => {
        this.setState({
            data: res.data.result
        })
    };

    render() {
        return (
            <div className='salesBackDetail-container'>
                <stub.ui.SceneContainer
                    module="cleanSealData"
                    options={{...this.props, model: this.state.data}}
                    sceneKey='cleanData-sealData-detail'/>

                <div className='salesBackDetail-addBtn salesBackDetail-addBtnBack'>
                    <Button onClick={() => {
                        stub.ui.helper.back()
                    }}>{stub.filter.transform('common.return')}</Button>
                </div>
            </div>
        )
    }

}

export default SealDataDetailComponent;
